import PageLayout from './PageLayout';

export default function AboutPage() {
  return (
    <PageLayout title="About">
      <p>About page coming soon.</p>
    </PageLayout>
  );
}
